'use client';

import { useRef } from 'react';

import { SearchDrawer } from '@eliadmin/core/src/components/header/search-bar/search-drawer';
import { Input } from '@eliadmin/core/src/components/ui/input';
import { Icon } from '@eliadmin/core/src/components/dlz/ui/icon';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/** Keep the DZL header controls; the shared drawer owns queries, results and navigation. */
export function HeaderSearch() {
  const { t } = useTranslations();
  const input = useRef<HTMLInputElement>(null);

  return (
    <SearchDrawer
      trigger={({ open, dialogId, openSearch }) => (
        <>
          <div className="hidden w-full min-w-0 max-w-[336px] flex-1 lg:block">
            <form
              role="search"
              aria-label={t('text211')}
              className="w-full"
              onSubmit={event => {
                event.preventDefault();
                openSearch(input.current);
              }}
              onClick={() => openSearch(input.current)}
            >
              <Input
                ref={input}
                type="search"
                enterKeyHint="search"
                autoComplete="off"
                readOnly
                value=""
                role="combobox"
                aria-label={t('text211')}
                aria-haspopup="dialog"
                aria-expanded={open}
                aria-controls={dialogId}
                placeholder="Vyhľadajte..."
                before={<Icon name="search-20" size={20} className="text-[#B9BDC3]" />}
                className={{
                  wrapper:
                    'h-[46px] focus-within:shadow-none [&_input::-webkit-search-cancel-button]:hidden',
                  before: 'pl-4',
                  main: 'pl-12 placeholder:text-[#9096A0]',
                }}
                onKeyDown={event => {
                  if (event.nativeEvent.isComposing || event.ctrlKey || event.altKey || event.metaKey)
                    return;
                  if (['Enter', ' ', 'ArrowDown'].includes(event.key)) {
                    event.preventDefault();
                    openSearch(event.currentTarget);
                  } else if (event.key.length === 1) {
                    event.preventDefault();
                    openSearch(event.currentTarget, event.key);
                  }
                }}
              />
            </form>
          </div>
          <button
            type="button"
            aria-label={t('text211')}
            aria-haspopup="dialog"
            aria-expanded={open}
            aria-controls={dialogId}
            onClick={event => openSearch(event.currentTarget)}
            className="-mr-2.5 flex size-11 items-center justify-center rounded-full text-[#0F1012] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0F1012] lg:hidden"
          >
            <Icon name="search" size={24} />
          </button>
        </>
      )}
    />
  );
}
